import { render, staticRenderFns } from "./VistaCotizacion.vue?vue&type=template&id=52c54f2c"
import script from "./VistaCotizacion.vue?vue&type=script&lang=js"
export * from "./VistaCotizacion.vue?vue&type=script&lang=js"
import style0 from "./VistaCotizacion.vue?vue&type=style&index=0&id=52c54f2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports